const Heart = ({ width }) => {
    return (
        <div className={`heart-icon ${width}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 100 100"
                version="1.1"
                viewBox="0 0 100 100"
                xmlSpace="preserve"
            >
                <path
                    d="M49.9 91.9L8.1 50.1c-9-9-9-23.6 0-32.6s23.6-9 32.6 0l9.2 9.2 9.2-9.2c9-9 23.6-9 32.6 0s9 23.6 0 32.6L49.9 91.9zM12.6 22c-6.5 6.5-6.5 17.1 0 23.6l37.3 37.3 37.3-37.3c6.5-6.5 6.5-17.1 0-23.6s-17.1-6.5-23.6 0L49.9 35.7 36.2 22c-6.5-6.5-17.1-6.5-23.6 0z"
                    className="st0"
                    fill="#414042"
                ></path>
            </svg>
        </div>
    )
}

export default Heart
